import React, {useState, useEffect} from "react";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { deleteUser } from "../../../redux/actions/users.actions";
import RootState from "../../../redux/states/root.state";
import { useSearchParams } from "react-router-dom";
import ModalShell, { ModalLoading } from "./ModalShell";


interface DeleteUserModalProps {
    isOpen: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    user: any;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({isOpen, setOpen, user}) => {
    const dispatch: AppDispatch = useDispatch();
    const searchParams = useSearchParams()[0];
    const {error} = useSelector((state: RootState) => state.users);
    const [success, setSuccess] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setSuccess(false);
            setIsDeleting(false);
        }
    }, [isOpen]);

    const handleClose = () => {
        setSuccess(false);
        setIsDeleting(false);
        setOpen(false);
    };

    const handleDelete = async () => {
        if(user){
            setIsDeleting(true);
            const result = await dispatch(
                deleteUser({user_id: user.id, params: searchParams.toString()})
            );

            if (deleteUser.fulfilled.match(result)) {
                setSuccess(true);
                setIsDeleting(false);
            } else {
                setIsDeleting(false);
            }
        }
    };

  return (
    <ModalShell
        open={isOpen}
        onClose={handleClose}
        size="sm"
        busy={isDeleting}
        tone={isDeleting ? undefined : error ? "error" : success ? "success" : "warning"}
        title={
            isDeleting ? "Deleting…"
            : error ? "An error occurred"
            : success ? "User deleted"
            : <>Delete <strong>{user?.name || user?.username}</strong>?</>
        }
        actions={isDeleting ? undefined : error || success ?
            <button className="btn btn-primary" onClick={handleClose}>OK</button>
            :
            <>
                <button className="btn" onClick={handleClose}>Cancel</button>
                <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
            </>
        }
    >
        {isDeleting ?
            <ModalLoading/>
            : error ?
            <p>An error occurred while deleting, please try again later.</p>
            : success ?
            <p>User successfully deleted.</p>
            :
            <p>This action cannot be undone.</p>
        }
    </ModalShell>
  );
};

export default DeleteUserModal;
